<template>
  <div v-show="hasFilters" class="adv-listing-used-filters">
    <div class="adv-listing-used-filters-content">
      <div class="native_slider">
        <div class="native_slider-lg" data-drag_speed="2">
          <!-- Flattened list of filters -->
          <div
            v-for="(filter, index) in flattenedFilters"
            :key="`${filter.type}-${index}`"
            class="native_slider-li"
          >
            <div class="checkbox">
              <label :for="`checkbox${index}`" class="checkbox_label">
                <a
                  :href="`${buildQueryString(filter.type, filter.value.id)}`"
                  class="active"
                  :title="filter.value.name"
                >
                  <span>{{ filter.value.name }}</span>
                  <i class="lni lni-close"></i>
                </a>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <slot name="extra-actions"></slot>
    <AdvListingUsedFiltersClear v-if="hasFilters"></AdvListingUsedFiltersClear>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AdvListingUsedFiltersClear from './AdvListingUsedFiltersClear.vue'

export default {
  name: 'AdvCurrentFilters',
  components: {
    AdvListingUsedFiltersClear
  },
  computed: {
    ...mapGetters([
      'getCurrentFilters'
    ]),
    currentFilters() {
      return this.getCurrentFilters;
    },
    hasFilters() {
      return Object.keys(this.currentFilters).some(
        (key) => this.currentFilters[key].length > 0
      );
    },
    flattenedFilters() {
      const flattened = [];
      for (const filterType in this.currentFilters) {
        this.currentFilters[filterType].forEach(filterValue => {
          flattened.push({ type: filterType, value: filterValue });
        });
      }
      return flattened;
    }
  },
  methods: {
    buildQueryString(filterType, filterValue) {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);

      let newParams = [];

      params.forEach((value, key) => {
        if (key === `${filterType}[]` && value === filterValue) {
          return;
        }
        newParams.push(`${key}=${encodeURIComponent(value)}`);
      });

      let queryString = newParams.length > 0 ? newParams.join('&') : '';

      return `${url.pathname}?${queryString}#list-page-start`;
    }
  }
}
</script>

<style lang="scss" scoped>
.adv-listing-used-filters {
  display: grid;
  gap: 0;
  grid-template-columns: auto auto auto;
  align-items: center;
  width: 100%;
  justify-content: flex-start;

  &-content {
    position: relative;
    width: 100%;
    max-width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;
  }

  .native_slider {
    max-height: 40px;
  }

  .native_slider-lg {
    grid-auto-columns: max-content;
    gap: 0;
  }

  @media screen and (max-width:767px) {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    grid-template-columns: none;
    align-items: flex-start;
    align-content: flex-start;
    height: fit-content;

    &-content {
      max-width: 100%;
      align-content: flex-start;
      align-items: flex-start;

      .native_slider {
        max-height: none;
      }

      .native_slider-lg {
        display: flex;
        flex-wrap: wrap;
        grid-auto-flow: unset;
        width: 100%;
        clip-path: none;
        padding: 0;
        margin: 0;
        overflow-y: auto;
        overflow-x: auto;
      }
    }
  }
}

.checkbox {
  position: relative;
  width: 100%;
  display: grid;
  margin: 0;
  border: 0;
  font-size: 14px;
  padding: 0 5px;
  line-height: 1.2;
  height: 36px;

  .checkbox_label {
    display: flex;
    padding: 0;
    cursor: pointer;
    color: #989898;
    font-size: 14px;
    line-height: 1.3;
    height: 100%;
    align-items: center;
    align-content: center;
    margin: 0;

    a {
      font-weight: 400;
      color: #989898;
    }

    &:before {
      display: none;
    }

    a {
      display: grid;
      gap: 5px;
      grid-template-columns: 1fr auto;
      align-items: center;

      i {
        background: var(--prime1);
        border-radius: 50%;
        color: #fff;
        padding: 5px;
        font-size: 10px;
        position: relative;
        width: 16px;
        height: 16px;
        text-align: center;

        &:before {
          top: 50%;
          transform: translateY(-50%);
          position: absolute;
          left: 0;
          right: 0;
          margin: 0 auto;
        }
      }
    }
  }

  .checkbox_input:checked+.checkbox_label::before {
    display: none;
  }
}

.native_slider-lg {
  @media screen and (max-width:767px) {
    .checkbox {
      flex: 0 0 auto;
      max-width: fit-content;
      padding-left: 0;

      .checkbox_label {
        padding-left: 0;
        padding-right: 0;
      }
    }
  }
}
</style>
